module.exports = __webpack_public_path__ + "fonts/dianyingzimuti-2.291cefaf.ttf";